(function ($) {
  var section = $('.resource-landing');
  if (section.length > 0) {
    var post_per_page = 15,
      items = $('.resource-grid .col-three'),
      $pagination = $('.resource-grid .pagination'), displayedPages;

    function filter(filter_items_arr) {
      var search_term = filter_items_arr[0].toLowerCase(),
        type_term = filter_items_arr[1].toLowerCase(),
        topic_term = filter_items_arr[2].toLowerCase(),
        product_term = filter_items_arr[3].toLowerCase();

      var queryParams = new URLSearchParams(window.location.search);
      if(type_term === "all_type" && topic_term === "all_topic" && product_term === "all_product"){
        history.replaceState(null, null, "/resources/");
      } else{
        if(product_term !== "all_product"){
          queryParams.set("product", product_term);
        } else{
          queryParams.delete("product");
        } 

        if(type_term !== "all_type"){
          queryParams.set("type", type_term);
        }else{
          queryParams.delete("type");
        }
        
        if(topic_term !== "all_topic" ){
          queryParams.set("topic", topic_term);
        }else{
          queryParams.delete("topic");
        }
        history.replaceState(null, null, "/resources/?"+queryParams.toString());
      }
        
      $('.resource-grid .col-three').addClass('hide').removeClass('show filtered');
      $('.resource-grid .col-three[data-search*="' + search_term + '"][data-topic*="' + topic_term + '"][data-product*="' + product_term + '"][data-type*="' + type_term + '"]').removeClass('hide filter-hide').addClass('show filtered');
      var numProductCards = $('.resource-grid .col-three.filtered').length;
      if (numProductCards < post_per_page) {
        $pagination.pagination('destroy');
      } else {
        pagination();
      }
      var itemLength = items.length;
      var hiddenitemLength = $('.resource-grid .col-three.hide').length;
      if (hiddenitemLength >= itemLength) {
        $('.resource-grid .no-result').show();
      } else {
        $('.resource-grid .no-result').hide();
      }
      if (search_term === "all_search" && type_term === "all_type" && topic_term === "all_topic" && product_term === "all_product") {
        $(".resource-grid .clear-btn").hide();
      } else {
        $(".resource-grid .clear-btn").show();
      }
    }

    $(window).on("load resize", function () {
      var win_Width = $(this).width();
      if (win_Width > 580) {
        displayedPages = 4;
      } else {
        displayedPages = 1;
      }
      pagination();
    });
    $(window).on("load", function () {
      var filter_items = ["all_search", "all_type", "all_topic", "all_product"];
      var search = $('#search');
      if (search.val() !== "") {
        filter_items[0] = search.val();
      }

      //Resources parameter exists
      let params = new URL(document.location).searchParams;
      if (params.size>0) {
        let type_name = params.get("type")
        let product_name = params.get("product")
        let topic_name = params.get("topic")
        let res_type = $('.filter-wrap .filter .selector-wrap.type .option-wrap li')
        let pro_type = $('.filter-wrap .filter .selector-wrap.product .option-wrap li')
        let topic_type = $('.filter-wrap .filter .selector-wrap.topic .option-wrap li')

        let res_found = datalist('.filter-wrap .filter .selector-wrap.type .option-wrap li').findIndex((element) => element == type_name)
        let pro_found = datalist('.filter-wrap .filter .selector-wrap.product .option-wrap li').findIndex((element) => element == product_name)
        let topic_found = datalist('.filter-wrap .filter .selector-wrap.topic .option-wrap li').findIndex((element) => element == topic_name)

        if (type_name && res_found >=0 ) {
          filter_items[1] = type_name
          res_type.parent().parent().find('span').text(capitalize(type_name))
        }

        if (product_name && pro_found >=0 ) {
          filter_items[3] = product_name
          pro_type.parent().parent().find('span').text(capitalize(product_name))
        }

        if (topic_name && topic_found >= 0) {
          filter_items[2] = topic_name 
          topic_type.parent().parent().find('span').text(capitalize(topic_name))
        }

        $('html, body').animate({scrollTop: $(".filter-wrap .filter .selector-wrap").offset().top - 90,}, 700, 'linear');
      }

      // search term
      search.on('input', function (e) {
        var text = $(this).val();
        if (text === "") {
          text = "all_search"
        }
        filter_items[0] = text;
        $('.resource-grid .no-result h3').text("No Result Found For " + text);
        filter(filter_items);
      });

      //Filter By Categories
      $('.filter-wrap .filter .selector-wrap.type .option-wrap li').on('click', function () {
        var data_text = $(this).attr("data-id");
        var text = $(this).text();
        $(this).parent().parent().find('span').text(text);
        filter_items[1] = data_text;
        filter(filter_items);
      });
      //Filter By Topic
      $('.filter-wrap .filter .selector-wrap.topic .option-wrap li').on('click', function () {
        var data_text = $(this).attr("data-id");
        var text = $(this).text();
        $(this).parent().parent().find('span').text(text);
        filter_items[2] = data_text;
        filter(filter_items);
      });
      //Filter By Product
      $('.filter-wrap .filter .selector-wrap.product .option-wrap li').on('click', function () {
        var data_text = $(this).attr("data-id");
        var text = $(this).text();
        $(this).parent().parent().find('span').text(text);
        filter_items[3] = data_text;
        filter(filter_items);
      });

      $(".resource-grid .clear-btn").on("click", function () {
        filter_items = ["all_search", "all_type", "all_topic", "all_product"];
        filter(filter_items);
        $(".filter-wrap .filter .selector-wrap").each(function () {
          var text = $(this).find('.option-wrap li').eq(0).text();
          $(this).find('.selector span').text(text);
          $('.filter-wrap .search-box input').val("");
        });
      })

      filter(filter_items);
    });

    $('.filter-wrap .filter .selector-wrap .option-wrap li').on('click', function () {
      $(this).parent().parent().parent().find('.selector-wrap').removeClass("active");
    });

    function filteredSwitchPage(pageNumber) {
      var showFrom = post_per_page * (pageNumber - 1);
      var showTo = showFrom + post_per_page;
      items.filter('.filtered').removeClass('filter').addClass("filter-hide");
      items.filter('.filtered').slice(showFrom, showTo).removeClass('filter-hide');
    }

    function smoothScrollTo($offset) {
      if ($offset.length) {
        $('html, body').animate({scrollTop: $offset.offset().top - 200,}, 700, 'linear');
      }
    }

    function pagination() {
      var numProductCards = $('.resource-grid .col-three.filtered').length;
      if (numProductCards > post_per_page) {
        items.filter('.filtered').slice(post_per_page).addClass('filter-hide');
        $pagination.pagination({
          items: numProductCards,
          itemsOnPage: post_per_page,
          displayedPages: displayedPages,
          ellipsePageSet: false,
          onPageClick: function (pageNumber, e) {
            e.preventDefault();
            e.stopPropagation();
            filteredSwitchPage(pageNumber);
            smoothScrollTo($(".filter-wrap .search-box input"));
          },
        });
      } else {
        $pagination.pagination('destroy');
      }
    }


  }


})(jQuery);